import Config from '@/config';
import http, { HttpPromise } from './http';

export default {
  updateTokens: async (params: { refresh: string }): Promise<HttpPromise> => {
    const data = new FormData();

    data.append('refresh', params.refresh);

    return http.post(`${Config.apiHost}/auth/update-tokens/`, data, {
      headers: {
        skipRenew: true,
      },
    });
  },
  async oauthLogin() {
    window.location.href = `${Config.apiHost}/auth/oauth2/authorize/`;
  },
};
